import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  verifyButton: {
    description: 'Button text to verify an item',
    defaultMessage: 'Verify',
    id: '+ObFfn',
  },
  clearButton: {
    description: 'Button text to clear an items verification',
    defaultMessage: 'Clear',
    id: 'TiwECu',
  },
  itemNameColumnHeader: {
    description: 'Column header for item name',
    defaultMessage: 'Item Name',
    id: 'YVpD2i',
  },
  imageColumnHeader: {
    description: 'Column header for item image',
    defaultMessage: 'Image',
    id: 'ydO7qV',
  },
  scannedColumnHeader: {
    description: 'Column header for scanned status',
    defaultMessage: 'Scanned',
    id: 'O/zIDR',
  },
  actionsColumnHeader: {
    description: 'Column header for actions',
    defaultMessage: 'Actions',
    id: '5a3P/D',
  },
});
